<template>
  <span>
    <span v-if="status === 'Received'" class="badge badge-success">Received</span>
    <span v-else-if="status === 'ReceivedDamaged'" class="badge badge-warning">Received Damaged</span>
    <span v-else-if="status === 'Cancelled'" class="badge badge-danger">Cancelled</span>
    <span v-else-if="status === 'Requested'" class="badge badge-secondary">Requested</span>
    <span v-else-if="status === 'InTransit'" class="badge badge-info">In Transit</span>
    <span v-else-if="status === 'Processing'" class="badge badge-secondary">Processing</span>
    <span v-else-if="status === 'Created'" class="badge badge-secondary">Created</span>
    <span v-else-if="status === 'Awaiting Review'" class="badge badge-primary">Awaiting Review</span>
    <span v-else class="badge badge-secondary">{{ status || 'Pending' }}</span>
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: ''
    }
  }
}
</script>
